import { render, staticRenderFns } from "./create-order-5g-sq.vue?vue&type=template&id=5a579937&scoped=true"
import script from "./create-order-5g-sq.vue?vue&type=script&lang=js"
export * from "./create-order-5g-sq.vue?vue&type=script&lang=js"
import style0 from "./create-order-5g-sq.vue?vue&type=style&index=0&id=5a579937&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a579937",
  null
  
)

export default component.exports